import React, {useState} from 'react'
import {Typography} from '@mui/material'
import {makeStyles} from '@mui/styles'
import Grid from '@mui/material/Grid'
import Constant from './SettingsConstants'
import {Colors} from './../../assets/styles'
import TextInput from '../TextInput'
import RXRButton from '../RXRButton'
import {resendStaffInvite} from '../../lib/queries'
import {useSelector} from 'react-redux'
import StaffPermissionsList from './StaffPermissionsList'
import SelectStaffUserType from './SelectStaffUserType'
import PropTypes from 'prop-types'
import {PERMISSION_GROUP_SUPER_ADMIN, PERMISSION_GROUP_VENDOR, PERMISSION_GROUP_GLOBAL_ADMIN} from '../../constants/ModelConstants'
import {isGlobalAdminUserType} from '../../Utils/globalAdminUtils'
import {CATEGORY_USER_TYPE} from '../Settings/SettingsConstants'
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  heading: {
    color: Colors.rxrRedColor,
  },
  inviteButton: {
    height: `55px !important`,
    width: '100%',
  },
}))

function UserForm(props) {
  const [isSendingInvite, setIsSendingInvite] = useState(false)
  const classes = useStyles()
  const activeBuildingId = useSelector(state => state.Buildings.activeBuildingId)
  const isCreateMode = !props.id
  const isEditingASuperAdminOrFormerUser = !isCreateMode && (props.userType === PERMISSION_GROUP_SUPER_ADMIN || props.isDisabled)
  const isNotEditable = isEditingASuperAdminOrFormerUser || [PERMISSION_GROUP_SUPER_ADMIN, PERMISSION_GROUP_VENDOR].includes(props.userType)
  const activeOrganization = useSelector(state => state.GlobalAdmin.organizationsLookup[state.GlobalAdmin.activeOrganizationId])

  const isEditingGlobalAdmin = isGlobalAdminUserType(activeOrganization, {id: props.id, permissionGroup: props.userType})

  const emailTextInput = (
    <TextInput
      label="Email Address"
      placeholder=""
      value={props.email}
      maxLength={120}
      onChange={val => props.updateForm({email: val})}
      isRequired={true}
      error={props.invalidItems.includes('email')}
      isDisabled={isNotEditable}
    />
  )

  const handleResendInvite = () => {
    setIsSendingInvite(true)
    resendStaffInvite(props.email, props.staffName, activeBuildingId)
      .then(() => {
        window.alert('Invite email has been sent successfully')
      })
      .catch(err => {
        window.alert('Failed to send invite email: ' + err.message)
      })
      .finally(() => {
        setIsSendingInvite(false)
      })
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        {isCreateMode && (
          <Grid item xs={12}>
            <Typography className={classes.heading}>{Constant.ALL_FIELDS_REQUIRED}</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <TextInput
            label="Staff name"
            placeholder=""
            maxLength={120}
            onChange={val => props.updateForm({staffName: val})}
            value={props.staffName}
            isRequired={true}
            isDisabled={isNotEditable}
            error={props.invalidItems.includes('staffName')}
          />
        </Grid>

        {!isCreateMode ? (
          <React.Fragment>
            <Grid item xs={9}>
              {emailTextInput}
            </Grid>
            <Grid item xs={3}>
              <RXRButton
                isLoading={isSendingInvite}
                className={classes.inviteButton}
                type={RXRButton.TYPE_SECONDARY}
                onClick={handleResendInvite}
                disabled={isNotEditable}
              >
                {'Resend invite'}
              </RXRButton>
            </Grid>
          </React.Fragment>
        ) : (
          <Grid item xs={12}>
            {emailTextInput}
          </Grid>
        )}

        <Grid item xs={6}>
          {isEditingGlobalAdmin ? (
            <TextInput
              label="User Type"
              value={CATEGORY_USER_TYPE[PERMISSION_GROUP_GLOBAL_ADMIN]}
              isDisabled={true}
              helperText={isEditingGlobalAdmin && Constant.DESCRIPTION_SETTINGS_USER_TYPE}
            />
          ) : (
            <SelectStaffUserType
              isNewUser={isCreateMode}
              value={props.userType}
              onChange={val => props.updateForm({userType: val})}
              error={props.invalidItems.includes('userType')}
              isDisabled={isNotEditable}
              excludeTypes={[CATEGORY_USER_TYPE[PERMISSION_GROUP_GLOBAL_ADMIN]]}
            />
          )}
        </Grid>
      </Grid>

      <StaffPermissionsList userType={props.userType} />
    </div>
  )
}

UserForm.propTypes = {
  id: PropTypes.string,
  userType: PropTypes.string,
  isDisabled: PropTypes.bool,
  email: PropTypes.string,
  staffName: PropTypes.string,
  invalidItems: PropTypes.arrayOf(PropTypes.string),
  updateForm: PropTypes.func,
}

export default UserForm
